import {
    SiPython,
    SiJavascript,
    SiTypescript,
    SiCplusplus,
    SiC,
    SiHtml5,
    SiCss3,
    SiPostgresql,
    SiGnubash,
    SiOpencv,
    SiPytorch,
    SiReact,
    SiFlask,
    SiNumpy,
    SiJupyter,
} from 'react-icons/si';
import { FaCode, FaMicrochip } from 'react-icons/fa';
import { DiJava } from 'react-icons/di';

// Icon mapping for languages
export const languageIcons = {
    'Python': SiPython,
    'JavaScript': SiJavascript,
    'TypeScript': SiTypescript,
    'C++': SiCplusplus,
    'C': SiC,
    'Java': DiJava,
    'HTML': SiHtml5,
    'CSS': SiCss3,
    'SQL': SiPostgresql,
    'Bash': SiGnubash,
    'Assembly': FaMicrochip,
};

// Icon mapping for technologies
export const technologyIcons = {
    'OpenCV': SiOpencv,
    'PyTorch': SiPytorch,
    'React': SiReact,
    'Flask': SiFlask,
    'NumPy': SiNumpy,
    'Jupyter': SiJupyter,
    'TensorBoard': FaCode,
    'PostgreSQL': SiPostgresql,
    'Python': SiPython,
    'PyQt6': SiPython,
    'LibTorch': SiPytorch,
    'YOLO': FaCode,
    'ModelZoo': FaCode,
    'Ultralytics YOLO': FaCode,
    'Roboflow': FaCode,
    'PyTorch Geometric': SiPytorch,
};

// Color mapping for icons
export const iconColors = {
    'Python': '#3776AB',
    'JavaScript': '#F7DF1E',
    'TypeScript': '#3178C6',
    'C++': '#00599C',
    'C': '#A8B9CC',
    'Java': '#007396',
    'HTML': '#E34F26',
    'CSS': '#1572B6',
    'SQL': '#4169E1',
    'PostgreSQL': '#4169E1',
    'Bash': '#4EAA25',
    'Assembly': '#654FF0',
    'OpenCV': '#5C3EE8',
    'PyTorch': '#EE4C2C',
    'React': '#61DAFB',
    'Flask': '#000000',
    'NumPy': '#013243',
    'Jupyter': '#F37626',
    'TensorBoard': '#FF6F00',
    'TensorFlow': '#FF6F00',
};
